import { createContext } from 'react';
import { UsersTypeAccessContextType } from 'types/UsersTypeAccessType';

export const UsersTypeAccessContext = createContext<UsersTypeAccessContextType|null>(null);
